/* =========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

export default {
  text: '',
  isSearchStalled: false,
  filters: {
    sortBy: 'recommended',
    time: 0,
    topics: []
  },
  videos: [
    {
      id: 1,
      title: 'bfg bgfbgf',
      slug: 'bfg-bgfbgf',
      description: 'bgfbgf gbgfbgf',
      script: 'bgfbgf gbgfbgf gfbgfbgfb fgbgfbgf',
      image: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      url: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      rating: 4,
      topic: 'Education',
      time: 90
    },
    {
      id: 2,
      title: 'sssss bgfbgf',
      slug: 'sssss-bgfbgf',
      description: 'bgfbgf gbgfbgf',
      script: 'bgfbgf gbgfbgf gfbgfbgfb fgbgfbgf',
      image: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      url: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      rating: 3,
      topic: 'Science',
      time: 10
    },
    {
      id: 3,
      title: 'sssss bgfbgf',
      slug: 'sssss-bgfbgf',
      description: 'bgfbgf gbgfbgf',
      script: 'bgfbgf gbgfbgf gfbgfbgfb fgbgfbgf',
      image: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      url: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      rating: 3,
      topic: 'Science',
      time: 10
    },
    {
      id: 4,
      title: 'sssss bgfbgf',
      slug: 'sssss-bgfbgf',
      description: 'bgfbgf gbgfbgf',
      script: 'bgfbgf gbgfbgf gfbgfbgfb fgbgfbgf',
      image: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      url: 'https://cdn-demo.algolia.com/bestbuy-0118/5388900_sb.jpg',
      rating: 3,
      topic: 'Science',
      time: 10
    }
  ]
};
